import { createDate, importAll, transformImages } from "utils";

import GalleryComponent from "components/Media/Gallery";
import QuibblerMain from "../../_hp-quibbler-main";
import QuibblerMakingOf from "../../_hp-quibbler-making-of";
import ReplicaBigTitle from "components/Replicas/ReplicaBigTitle";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];
let galleryArticles = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
  galleryArticles = importAll(
    (require as any).context("./gallery-articles", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <QuibblerMain
        gallery={transformImages(gallery)}
        galleryImageOptions={[
          { index: 0, aspectRatio: 1.5 },
          { index: 5, aspectRatio: 1.5 },
          { index: 8, aspectRatio: 1.5 },
          { index: 10, aspectRatio: 1.5 },
        ]}
        video={"https://youtu.be/xb6IIkItP6A"}
      />

      <ReplicaBigTitle title="A Nation in Panic!" />

      <ReplicaParagraph>
        Judging by the headlines on the front cover, it's safe to assume that
        this issue of The Quibbler was published sometime during the events of
        Half-Blood Prince — a period when You-Know-Who’s return had finally been
        acknowledged, and he was widely believed to be behind the strange
        accidents and disappearances from the previous year. It’s also clear
        that the Ministry had not yet fallen under Death Eater control and was
        still attempting to protect the wizarding public. Naturally, The
        Quibbler was there to tell readers how things “really” were. The
        articles in this issue focus heavily on Death Eaters, unexplained
        incidents, and wild conspiracy theories involving dark magic.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryArticles)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <QuibblerMakingOf />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
